import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Close } from '@mui/icons-material';
import { Divider, IconButton, TextField, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { FormDatePicker } from '../../builderPackage/components/dynamicFormBuilder/components/formDatePicker';
import { FormSearchSelect } from '../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect';
import { MuiStack } from '../../components';
import { fetchFutureAdviceTypes, fetchStatusByEntityId } from './apiCalls';
var FutureAdviseDetailPopup = function (_ref) {
    var data = _ref.data, isDisabled = _ref.isDisabled, onClose = _ref.onClose, onUpdate = _ref.onUpdate;
    var _a = useState(_objectSpread({}, data)), formData = _a[0], setFormData = _a[1];
    var _b = useState({}), touched = _b[0], setTouched = _b[1];
    var handleClose = function () {
        onClose(formData);
    };
    var markTouched = useCallback(function (field) {
        setTouched(function (prev) {
            var _a;
            return _objectSpread(_objectSpread({}, prev), {}, (_a = {},
                _a[field] = true,
                _a));
        });
    }, []);
    var errors = useMemo(function () {
        var e = {};
        var hasFAType = !!formData.FutureAdviceTypeId;
        if (hasFAType) {
            if (!formData.SuggestionContent) {
                e.SuggestionContent = "You\u2019ve added a future advice line. Please provide the details or remove the line to proceed ";
            }
            else if (formData.SuggestionContent.length > 1000) {
                e.SuggestionContent = 'Future Advice Details cannot exceed 1000 characters.';
            }
            if (!formData.DueDate) {
                e.DueDate = "Please enter a due date for the all Future Advice.";
            }
            else {
                var today = dayjs().startOf('day');
                var selectedDate = dayjs(formData.DueDate).startOf('day');
                if (selectedDate.isBefore(today)) {
                    e.DueDate = 'Past due date is not allowed. Please select present or future date.';
                }
            }
            if (!formData.StatusId) {
                e.StatusId = 'Status is required.';
            }
        }
        return e;
    }, [formData]);
    useEffect(function () {
        setFormData(_objectSpread({}, data));
    }, [data]);
    useEffect(function () {
        onUpdate === null || onUpdate === void 0 || onUpdate(formData);
    }, [formData]);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        padding: 2.5,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        fontWeight: 600
    }, t('Future advice')), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        onClick: handleClose
    }, /*#__PURE__*/ React.createElement(Close, null))), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary",
        fontWeight: 500
    }, t('FA type')), /*#__PURE__*/ React.createElement(FormSearchSelect, {
        id: "FutureAdviceTypeId",
        name: "FutureAdviceTypeId",
        placeholder: t('Select future advice'),
        fullWidth: true,
        value: formData.FutureAdviceTypeId || '',
        disabled: isDisabled,
        displayExpr: "Name",
        valueExpr: "id",
        getListData: fetchFutureAdviceTypes,
        apiKey: "futureAdviseTypes",
        onChange: function (e, value) {
            console.log('Selected FA Type:', value);
            if (value) {
                setFormData(function (prev) {
                    var _value$id, _value$Name;
                    return _objectSpread(_objectSpread({}, prev), {}, {
                        FutureAdviceTypeId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : '',
                        FutureAdviceTypeName: (_value$Name = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name !== void 0 ? _value$Name : ''
                    });
                });
            }
            else {
                setFormData(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                    FutureAdviceTypeId: null,
                    FutureAdviceTypeName: null,
                    SuggestionContent: null,
                    DueDate: null,
                    StatusId: null,
                    StatusName: null
                }); });
            }
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary",
        fontWeight: 500
    }, t('Future advise details')), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        multiline: true,
        rows: 4,
        size: "small",
        placeholder: t('Enter remarks'),
        value: formData.SuggestionContent || '',
        error: touched.SuggestionContent && !!errors.SuggestionContent,
        helperText: touched.SuggestionContent && errors.SuggestionContent || "".concat((formData.SuggestionContent || '').length, "/1000 characters"),
        onBlur: function () { return markTouched('SuggestionContent'); },
        onChange: function (e) {
            var value = e.target.value;
            if (value.length <= 1000) {
                setFormData(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                    SuggestionContent: value
                }); });
            }
        },
        disabled: !formData.FutureAdviceTypeId || isDisabled
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary",
        fontWeight: 500
    }, t('Due date')), /*#__PURE__*/ React.createElement(FormDatePicker, {
        name: "DueDate",
        value: formData.DueDate,
        placeholder: t('Select due date'),
        error: touched.DueDate ? errors.DueDate : undefined,
        onChange: function (e, value) {
            markTouched('DueDate');
            setFormData(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                DueDate: value ? new Date(value) : null
            }); });
        },
        disabled: !formData.FutureAdviceTypeId || isDisabled
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary",
        fontWeight: 500
    }, t('Status')), /*#__PURE__*/ React.createElement(FormSearchSelect, {
        id: "StatusId",
        name: "StatusId",
        placeholder: t('Select status'),
        fullWidth: true,
        value: formData.StatusId || '',
        displayExpr: "DisplayName",
        valueExpr: "id",
        getListData: fetchStatusByEntityId,
        apiKey: "statusByEntityId",
        error: touched.StatusId ? errors.StatusId : undefined,
        onChange: function (e, value) {
            markTouched('StatusId');
            setFormData(function (prev) {
                var _value$id2, _value$DisplayName;
                return _objectSpread(_objectSpread({}, prev), {}, {
                    StatusId: (_value$id2 = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id2 !== void 0 ? _value$id2 : '',
                    StatusName: (_value$DisplayName = value === null || value === void 0 ? void 0 : value.DisplayName) !== null && _value$DisplayName !== void 0 ? _value$DisplayName : ''
                });
            });
        },
        disabled: !formData.FutureAdviceTypeId || isDisabled
    })));
};
export default FutureAdviseDetailPopup;
